
import { mapState } from 'vuex';

import Button from './Button.vue'

export default {
  name: 'TopSellers',
  components: { Button },
  props: {
    blok: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      show: true,
    }
  },
  mounted() {
    if (this.blok && this.blok.show === 'no-user' && this.user) {
      this.show = false
    }
  },
  computed: {
    ...mapState(['user', 'location']),
    bgVariants() {
      return [
        this.blok.background_color ? `bg--${this.blok.background_color}` : '',
      ]
    },
    layout() {
      return this.blok.layout ? this.blok.layout : ''
    },
  },
  methods: {
    goTo() {
      const to = this.location && this.location.menu_id
          ? `/menu/${this.location.menu_id}`
          : `/locations`
      this.$router.push(to);
    },
  }
}
